import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_instance_view = _resolveComponent("ontos-instance-view")!
  const _component_ontos_view_instance_dialog = _resolveComponent("ontos-view-instance-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_component_ontos_instance_view, {
      ref: "view",
      key: _ctx.contentKey,
      framed: "",
      context: _ctx.context,
      workspace: _ctx.workspace,
      onOpenInstance: _ctx.onOpenInstance,
      onEdit: _ctx.onEdit,
      onChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChanged($event))),
      onDeleted: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({name: 'list-instances', params: _ctx.$route.params}))),
      onNotFound: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({name: 'home'}))),
      onCrumb: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('crumb', $event))),
      onShowMessage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('showMessage', $event))),
      onShowErrorMessage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
    }, null, 8, ["context", "workspace", "onOpenInstance", "onEdit"])),
    (_ctx.instanceOnView)
      ? (_openBlock(), _createBlock(_component_ontos_view_instance_dialog, {
          key: 0,
          context: _ctx.instanceOnView,
          preview: _ctx.previewOnView,
          workspace: _ctx.workspace,
          onChanged: _cache[6] || (_cache[6] = ($event: any) => (_ctx.reloadNonce++)),
          onDeleted: _ctx.onChildDeleted,
          onClosed: _cache[7] || (_cache[7] = ($event: any) => (_ctx.instanceOnView = null)),
          onShowMessage: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('showMessage', $event))),
          onShowErrorMessage: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
        }, null, 8, ["context", "preview", "workspace", "onDeleted"]))
      : _createCommentVNode("", true)
  ]))
}